// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1kdyT","title":"Header_title__z06bd","side":"Header_side__I3M3a"};